import { START } from 'shared/data/quoteSteps';
import defaultParameters from 'mx_pcb_assembly/data/defaultParameters';
import defaultQuote from 'mx_pcb_assembly/data/defaultQuote';
import defaultSuppliers from 'mx_pcb_assembly/data/defaultSuppliers';

export default {
  loading: false,
  parametersChanged: false,
  parameters: defaultParameters,
  suppliers: defaultSuppliers,
  quote: defaultQuote,
  quoteStep: START,
  currentVariant: null,
  lineItemId: null,
};
